import AppSideBar from '@/components/appSideBar';
import BrowserBackInterceptor from '@/components/browserBackInterceptor';
import GlobalSaveFileDialog from '@/components/globalSaveFileDialog';
import LoadingPlaceholder from '@/components/loadingPlaceholder';
import * as terminalApi from '@/api/terminal';
import { FileEditorMapService } from '@/utils/fileEditorMapService';
import useFileStore from '@/utils/fileStore';
import { websocketService } from '@/utils/websocketService';
import { Layout } from 'antd';
import React, { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useTranslation } from 'react-i18next';
import { shareWithMeService } from '@/utils/shareWithMeService';
import { useCopyConfig } from '@/hooks/useCopyConfig';

const App: React.FC = () => {
    const {  i18n } = useTranslation();
    const { loadCopyConfigs } = useCopyConfig();
    // file store
    const initializeTreedata = useFileStore(state => state.initializeTreedata);
    const baseHome = useFileStore(state => state.baseHome);

    useEffect(() => {
        

        const initializeApp = async () => {
            const locale = typeof navigator !== 'undefined' ? navigator.language : undefined
            await i18n.changeLanguage(locale);
            // 加载动态文案配置
            await loadCopyConfigs();
            // 初始化文件树
            await initializeTreedata();
            FileEditorMapService.initialize();
            // 初始化“与我共享”数据
            await shareWithMeService.initialize();
            const userName = localStorage.getItem('userName');

            if (userName && baseHome) {
                // 获取terminal PID
                let terminalPid: string | undefined;
                try {
                    const res = await terminalApi.getPty();
                    if (res.ok && res.data?.pid) {
                        terminalPid = res.data.pid;
                    }
                } catch (error) {
                    console.error('Failed to get terminal PID:', error);
                }
                // 初始化统一的WebSocket连接
                await websocketService.initialize({
                    userName,
                    baseHome,
                    terminalPid
                });
            }
        };

        initializeApp();

        // 组件卸载时销毁WebSocket连接
        return () => {
            websocketService.disconnect();
        };
    }, [baseHome])

    useEffect(() => {

        return () => {
            if (websocketService.isConnectedStatus()) {
                websocketService.destroy();
            }
        }
    }, [])

    return (

        <Layout className='w-full h-full'>
            <Layout className='w-full h-full'>
                <LoadingPlaceholder fullScreen={true} size={'large'} />
                <AppSideBar />
                <div className='main-container overflow-hidden flex flex-row w-full h-full'>
                    <Outlet />
                </div>
                {/* 全局的 SaveFileDialog */}
                <GlobalSaveFileDialog />
                {/* 全局的浏览器返回拦截 */}
                <BrowserBackInterceptor />
            </Layout>
        </Layout>
    );
};

export default App